import React from 'react'
import Image from 'next/image'
import Link from 'next/link'

const BlogCard = ({
    title,
    summary,
    id,
    storyImage,
    feedImage,
    author,
    timestamp,
}) => {
    let slugId = id?.includes('/p/') ? id.split('/p/')[1] : id

    return (
        <Link href={`/blogs/${slugId}`}>
            <div className=" max-w-[1300px] p-4 rounded-xl flex flex-col hover:bg-gray-300 hover:dark:!bg-black  hover:scale-[1.02] gap-3 md:gap-2">
                <div className="">
                    <Image
                        src={storyImage}
                        width={300}
                        height={300}
                        className="rounded-lg w-full h-[200px] object-cover"
                    />
                </div>
                <div className="mt-2">
                    <div className="flex flex-col gap-3 ">
                        <h2 className=" text-[18px] font-bold text-black dark:!text-white  line-clamp-2">
                            {title}
                        </h2>

                        <p className=" text-sm font-normal dark:!text-[#FFFFFFB3] text-black line-clamp-3">
                            {summary}
                        </p>

                        <div className="flex justify-start mt-1">
                            <Image
                                src={feedImage}
                                width={36}
                                height={36}
                                className="rounded-lg w-[36px] h-[36px] object-cover mr-4"
                            />
                            <div className="">
                                <p className="text-sm font-medium text-gray-400">
                                    {author}
                                </p>
                                <p className="text-sm text-gray-400">
                                    Posted on:{' '}
                                    {new Date(timestamp).toDateString()}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Link>
    )
}
export default BlogCard
